<template>
  <div
    v-if="!loading"
    ref="passDetail"
    class="pass-detail"
  >
    <detail-header
      ref="header"
      :crumb="showCrumb"
      :menu-datas="menuDatas"
      :code="code"
      :inquiry-id="inquiryId"
      @backList="goBackList"
    />
    <div
      v-if="!loading && Object.keys(detailData).length > 0"
      ref="container"
      class="container clue-container"
    >
      <!-- 概览 -->
      <!-- <member-module ref="memberModule" /> -->
      <div
        ref="containerInner"
        class="inner clearfix"
      >
        <div
          ref="containerRight"
          class="container-right"
        >
          <right-tabs
            ref="rightTabs"
          />
        </div>
        <div
          ref="containerLeft"
          class="container-left"
        >
          <!-- 审核通过的询盘详情 -->
          <div class="container-left-con">
            <left-tabs
              ref="leftTabs"
              :form-data="formData"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="!loading && Object.keys(detailData).length === 0"
      class="spin-fixed-center no_data"
    >
      <p><i class="iconfont iconicon-test38 logo" /></p>
      <p>
        {{ $t('message["343"]') }}
      </p>
    </div>
    <a-spin
      v-else
      class="spin-fixed-center"
    />
    <gallery />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import DetailHeader from './Header'
// import MemberModule from './MemberInfo'
import LeftTabs from './LeftTabs'
import RightTabs from './RightTabs'
import Gallery from '@/components/pc/Gallery'
import eventBus from '@/lib/eventBus'
import { getH } from '@/store/universalForm/convert'
// import { setReplyPositionQuery } from '@/lib/before-router'

const FROM_SOPURCE = 'notice'

export default {
  components: {
    DetailHeader,
    // MemberModule,
    LeftTabs,
    RightTabs,
    Gallery
  },
  props: {

  },
  data () {
    return {
      showCrumb: true,
      activeName: '',
      system_role: '',
      isFold: false
    }
  },
  computed: {
    ...mapState(['menuDatas']),
    ...mapState('inquery/detailData', [
      'loading',
      'detailData'
    ]),
    ...mapGetters('inquery/detailData', [
      'formData',
      'permissionInfo'
    ]),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from || ''
    },
    type () {
      return this.$route.query.type
    },
    routeName () {
      return this.$route.name
    },
    code () {
      return (this.detailData && this.detailData.info && this.detailData.info.code) || ''
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    auditStatus () {
      const { info = {} } = this.detailData
      const { audit_status: auditStatus } = info
      return auditStatus
    },
    showPassTab () {
      let flag = false
      if (this.from === 'audit') {
        flag = false
      } else {
        if (this.auditStatus === 0 || this.auditStatus === -1) {
          flag = false
        } else if (this.auditStatus === 1) {
          flag = true
        }
      }
      return flag
    },
    clueId () {
      return this.$route.params.id
    }
  },
  watch: {
    $route: {
      handler: async function (val, oldVal) {
        const { id: newInquiryId } = val.params
        const { id: oldInquiryId } = oldVal.params
        // console.log(newInquiryId, oldInquiryId)
        if (newInquiryId !== oldInquiryId) {
          await this.getDetail()
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  beforeRouteEnter (to, from, next) {
    const { page } = to.query
    next(vm => {
      if (page === FROM_SOPURCE) {
        vm.showCrumb = false
      }
    })
  },
  async created () {
    await this.getDetail()
  },
  mounted () {
    eventBus.$on('fetchInquiryDetail', this.getDetail)
    eventBus.$on('getInnerHeight', this.getInnerHeight)
    // 获取询盘规则重置后的提示说明
  },
  beforeDestroy () {
    eventBus.$off('fetchInquiryDetail', this.getDetail)
    eventBus.$off('getInnerHeight', this.getInnerHeight)
  },
  destroyed () {
    this.UPDATA_DETAIL({})
  },
  methods: {
    ...mapActions(['permissionMenu']),
    ...mapActions('inquery/detailData', ['fetchDetail']),
    ...mapActions('inquery/relateData', ['fetchRecycleLogTip']),
    ...mapMutations('inquery/detailData', ['UPDATA_DETAIL', 'SET_LOADING']),
    getH,
    async getDetail (inquiryId, type) {
      const chain = await this.fetchDetail({ type: 'clue' })
      chain
        .params({
          clueid: this.clueId,
          scope: this.from,
          checkrepeatfieldkey: this.checkrepeatfieldkey
        })
        .onFail((e, error) => {
          this.SET_LOADING(false)
        })
        .onNetSuccess((res = {}) => {
          this.setTitle(res)
          this.redirectRouter()
          this.$nextTick(() => {
            this.getInnerHeight()
          })
        })
        .fetch()
    },
    async setTitle (res) {
      let projectname, comname
      let { baseinfo = {} } = res.data || {}
      comname = baseinfo.comname
      projectname = baseinfo.projectname

      this.system_role = baseinfo.system_role
      const chain = await this.permissionMenu()
      chain.onSuccess(res => {
        const { permissionMenuList = {} } = this.menuDatas
        let parent = {}
        if (this.from === 'my') {
          parent = permissionMenuList['inquiry-mine']
        } else if (this.from === 'all') {
          parent = permissionMenuList['inquiry-all']
        } else if (this.from === 'audit') {
          parent = permissionMenuList['inquiry-audit']
        }
        let { child = {} } = parent || {}
        // console.log(this.type, child)
        let { name = '' } = (child && child[this.type]) || {}

        if (this.from === 'notice') {
          name = this.$t('message["1215"]')
        } else if (this.from === 'webhook') {
          name = '推送记录'
        } else if (this.from === 'clue') {
          name = '线索管理'
        }

        if (name) {
          document.title = name + '-' + projectname + '-' + comname
        } else {
          document.title = projectname + '-' + comname
        }
      })
    },
    redirectRouter () {
      // const noticeQuery = setReplyPositionQuery()
      // let routerName = ''
      // 如果 pc 打开移动端发送的 InqueryDetail 链接
      // if ((this.auditStatus === 0 || this.auditStatus === -1) && this.$route.name === 'InqueryPassDetail') {
      //   routerName = 'InqueryDetail'
      // } else if (this.auditStatus === 1 && (this.$route.name === 'InqueryDetail')) {
      //   routerName = 'InqueryPassDetail'
      // }
      // if (noticeQuery) {
      //   this.$router.push({ ...this.$route, name: routerName, query: noticeQuery })
      // } else {
      //   this.$router.push({ ...this.$route, name: routerName })
      // }
    },
    async goBackList () {
      this.$router.push({ ...this.$route, name: 'InqueryClue' })
    },
    async setCustomRoleRoute () {
      let linkName, routerName
      const chain = await this.permissionMenu() // 先请求菜单数据，判断自定义角色默认展示页
      return new Promise(async (resolve, reject) => {
        await chain
          .onSuccess(res => {
            for (let key in res) {
              if (key === 'inquiry-mine' && res[key]['state']) {
                let item = res[key]
                if ('child' in item) {
                  for (let cKey in item['child']) {
                    linkName = { type: cKey, from: 'my' }
                    break
                  }
                }
                break
              }
              if (key === 'inquiry-mine' && !res[key]['state']) {
                // console.log('查重： inquiry-check-repeat')
                routerName = 'InqueryRepeat'
                linkName = {}
                break
              }
            }
            resolve({ routerName, linkName })
          })
          .onNetFail(err => {
            reject(err)
          })
      })
    },
    getInnerHeight () {
      let $containerInner = this.$refs.containerInner
      let $memberModule = this.$refs.memberModule && this.$refs.memberModule.$el
      let $header = this.$refs.header && this.$refs.header.$el
      if ($containerInner) {
        let memberModuleHeight = ($memberModule && $memberModule.offsetHeight) || 0
        let headerHeight = $header.offsetHeight + 16
        // let alertHeight = $alert.offsetHeight
        let h = memberModuleHeight + headerHeight + 16
        getH($containerInner, h)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.pass-detail {
  overflow-y: hidden;
  .container {
    width: 1280px;
    // height: calc(100vh - 94px);
    margin: 16px auto 0;
    border: solid 1px $gray4;
    border-radius: 5px;
    overflow: hidden;
    .inner {
      position: relative;
      width: 100%;
      overflow: hidden;
      transition: all 0.1s;
    }
  }
  .container-left {
    position: relative;
    height: 100%;
    vertical-align: top;
    margin-right: 496px;
    padding: 0 16px 0 0;
    background-color: #FBFBFB;;
    border-right: solid 1px $gray4;
    .container-left-con{
      height: 100%;
      padding:24px 8px 0 40px;
      background-color: #fff;
      border-right: solid 1px $gray4;
    }
  }
  .container-right {
    float: right;
    width: 496px;
    height: 100%;
    padding: 40px 40px 0;
    vertical-align: top;
    background-color: #fff;
  }
  .no_data {
    margin-top: 140px;
    .logo {
      font-size: 40px;
    }
    p {
      text-align: center;
      height: 24px;
      font-size: 15px;
      font-weight: 400;
      color: rgba(179, 179, 179, 1);
      line-height: 24px;
      margin-bottom: 8px;
    }
    .text {
      margin: 20px auto;
    }
  }
}
</style>
